import api_config from '../../server_config/http'
import axios from 'axios'
import { Toast } from 'vant'
// 售后联系商家客服
const linkChat = async ($http:any,$store:any,storeId: any) => {
    let storeInfo: any = {}
    const res: any = await $http.getChatRoom({ store_id: storeId })
    if (res.code === 200) {
        storeInfo = res.data
        let shop_info: any = storeInfo.extra_info.user_info.filter((item: any) => item.id != common.getStorage("user_info").id)
        location.href = `${window.common.old_url()}/message_list_item?token=${$store.getToken()}&mid=${shop_info[0].id
            }&uid=${common.getStorage("user_info").id}&store_name=${shop_info[0].name
            }&type=shop&storeImgs=${shop_info[0].avatar}`;
    }
};
// 获取视频/图片拼接路径及格式信息
const getFilePath = async () => {
    let url = api_config.javaApiUrl.indexOf('kilitest') == -1 ? 'https://image.kilimall.com' : 'https://image.kilitest.com'
    const res: any = await axios.get(`${url}/global/aftersale/media_setting.json`)
    if (res.status === 200) {
        return res.data
    } else {
        Toast(res.msg)
    }
}
// 获取售后开关
const getShowAfter = async () => {
    let url = api_config.javaApiUrl.indexOf('kilitest') == -1 ? 'https://image.kilimall.com' : 'https://image.kilitest.com'
    const res: any = await axios.get(`${url}/file_cache/ke/global_setting.json`)
    if (res.status === 200) {
        return res.data
    } else {
        Toast(res.msg)
    }
}

// 获取售后协议链接
const getRuleUrl = async() => {
    let url = api_config.javaApiUrl.indexOf('kilitest') == -1 ? 'https://image.kilimall.com' : 'https://image.kilitest.com'
    const res: any = await axios.get(`${url}/file_cache/ke/file_map_static_cache.json`)
    const afterRuleUrl = res.data.after_sale_config.url
    const afterRes: any = await axios.get(afterRuleUrl)
    if (afterRes.status === 200) {
        return afterRes.data
    } else {
        Toast(afterRes.msg)
    }
}
// 使用获取到的上传密钥链接上传文件
const putUpload = async(params:any) => {
    const res: any = await axios({
        method: 'put',
        url: params.url,
        data: params.file,
        headers: { 'Content-Type': params.file.type}
    })
    return res
}
export {
    linkChat,
    getFilePath,
    getShowAfter,
    getRuleUrl,
    putUpload
}